import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "overflow-x-auto" }
const _hoisted_2 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_3 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_4 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_5 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_6 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_7 = { class: "text-sm text-gray-500" }
const _hoisted_8 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_9 = { class: "px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800" }
const _hoisted_10 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_11 = { class: "px-6 py-4 whitespace-nowrap text-right text-sm font-medium" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  colspan: "5",
  class: "px-6 py-4 bg-gray-50 border-t border-gray-200"
}
const _hoisted_15 = { class: "flex space-x-3" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "text-sm text-gray-500 italic"
}
const _hoisted_18 = { key: 0 }

import { ref } from 'vue';
import { TaskDocProfile } from '@/features/task-management';
import EmailReviewModal from '../EmailReviewModal.vue';
import { useEmailReminder } from '@/composables/useEmailReminder';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'RemindersTab',
  props: {
    reminders: {}
  },
  setup(__props: any) {



// State
const expandedReminderId = ref<string | null>(null);

// Toggle expanded reminder
const toggleReminderExpanded = (reminderId: string) => {
  if (expandedReminderId.value === reminderId) {
    expandedReminderId.value = null;
  } else {
    expandedReminderId.value = reminderId;
  }
};

// Use the email reminder composable
const {
  showEmailModal,
  currentTaskData,
  showEmailReminderModal,
  closeEmailModal,
  handleEmailSendSuccess
} = useEmailReminder();

// Format date
const formatDate = (dateString: string | null | undefined) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

// Get due date class based on date
const getDueDateClass = (dateString: string | null | undefined) => {
  if (!dateString) return 'text-gray-500';
  
  const dueDate = new Date(dateString);
  const today = new Date();
  
  // Reset time part for accurate day calculation
  dueDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);
  
  if (dueDate < today) {
    return 'text-red-500'; // Overdue
  } else if (dueDate.getTime() === today.getTime()) {
    return 'text-yellow-500'; // Due today
  } else {
    return 'text-gray-500'; // Future
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("thead", { class: "bg-gray-50" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              scope: "col",
              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            }, "Document"),
            _createElementVNode("th", {
              scope: "col",
              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            }, "User"),
            _createElementVNode("th", {
              scope: "col",
              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            }, "Action"),
            _createElementVNode("th", {
              scope: "col",
              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            }, "Due Date"),
            _createElementVNode("th", {
              scope: "col",
              class: "relative px-6 py-3"
            }, [
              _createElementVNode("span", { class: "sr-only" }, "Actions")
            ])
          ])
        ], -1)),
        _createElementVNode("tbody", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reminders, (reminder) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: reminder.id
            }, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(reminder.document_name), 1)
                ]),
                _createElementVNode("td", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(reminder.user_name), 1)
                ]),
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(reminder.action), 1)
                ]),
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["text-sm", getDueDateClass(reminder.due_at)])
                  }, _toDisplayString(formatDate(reminder.due_at)), 3)
                ]),
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (toggleReminderExpanded(reminder.id)),
                    class: _normalizeClass(["text-primary hover:text-primary-dark transition-transform duration-200", { 'transform rotate-180': expandedReminderId.value === reminder.id }])
                  }, _cache[0] || (_cache[0] = [
                    _createElementVNode("svg", {
                      class: "h-5 w-5",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M19 9l-7 7-7-7"
                      })
                    ], -1)
                  ]), 10, _hoisted_12)
                ])
              ]),
              (expandedReminderId.value === reminder.id)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        (reminder.action === 'DOWNLOAD')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: ($event: any) => (_unref(showEmailReminderModal)(reminder.document_id, reminder.user_name, reminder.user_email, reminder.action)),
                              class: "inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                            }, _cache[1] || (_cache[1] = [
                              _createElementVNode("svg", {
                                class: "h-4 w-4 mr-1",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                })
                              ], -1),
                              _createTextVNode(" Send Reminder ")
                            ]), 8, _hoisted_16))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, " No actions available "))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_ctx.reminders.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_18, _cache[2] || (_cache[2] = [
                _createElementVNode("td", {
                  colspan: "5",
                  class: "px-6 py-10 text-center"
                }, [
                  _createElementVNode("p", { class: "text-gray-500" }, "No reminders available")
                ], -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(EmailReviewModal, {
      "is-open": _unref(showEmailModal),
      "process-step-type": 'DOWNLOAD',
      "recipient-email": _unref(currentTaskData).email,
      "template-variables": _unref(currentTaskData),
      onClose: _unref(closeEmailModal),
      onSendSuccess: _unref(handleEmailSendSuccess)
    }, null, 8, ["is-open", "recipient-email", "template-variables", "onClose", "onSendSuccess"])
  ]))
}
}

})